import { ShareholderDocumentsToGetAll, ShareholderDocumentsToGetAllRequest } from 'model/shareholder-documents.model';
import { api } from 'services/api/api';
import { Page } from 'services/page';

const apiUrl = '/api/shareholder-documents';

const shareholderDocumentsApi = () => {
    const getDocuments = (request: ShareholderDocumentsToGetAllRequest) =>
        api.get<Page<ShareholderDocumentsToGetAll>>(`${apiUrl}/${request?.personId}`, {
            params: request
        });

    const downloadDocument = (documentId: number) =>
        api.get<Blob>(`${apiUrl}/${documentId}/download`, {
            responseType: 'blob'
        });

    return {
        getDocuments,
        downloadDocument
    };
};

export default shareholderDocumentsApi();
